"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRemarkInformation = exports.success = void 0;
const fp = require("fp-ts");
const translation_1 = require("./translation");
const validation_1 = require("./validation");
exports.success = true;
function validateRemarkInformation(data, opts = {}) {
    return fp.function.compose((0, validation_1.ap)((0, validation_1.isNotEmpty)('responsible_company')(data)), (0, validation_1.ap)(data.must_be_fixed_at
        ? data.must_be_fixed_at.toString().length > 0
            ? fp.validation.success(exports.success)
            : fp.validation.failure([
                {
                    key: 'must_be_fixed_at',
                    value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
                }
            ])
        : fp.validation.failure([
            {
                key: 'must_be_fixed_at',
                value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
            }
        ])))(validation_1.successValidation);
}
exports.validateRemarkInformation = validateRemarkInformation;
//# sourceMappingURL=remarkValidation.js.map